import { useMemo, useState } from 'react';

export default function useRestaurantePedidoCart() {
  const [items, setItems] = useState([]);

  const agregar = (producto) => {
    if (!producto) return;

    setItems((actual) => {
      const existente = actual.find(
        (item) => item.id === producto.id
      );

      if (existente) {
        return actual.map((item) =>
          item.id === producto.id
            ? {
                ...item,
                cantidad: item.cantidad + 1,
              }
            : item
        );
      }

      return [
        ...actual,
        {
          ...producto,
          cantidad: 1,
          observaciones: '',
        },
      ];
    });
  };

  const cambiarCantidad = (id, delta) => {
    setItems((actual) =>
      actual
        .map((item) =>
          item.id === id
            ? {
                ...item,
                cantidad: Math.max(
                  0,
                  Number(item.cantidad) + delta
                ),
              }
            : item
        )
        .filter((item) => item.cantidad > 0)
    );
  };

  const cambiarObservaciones = (id, observaciones) => {
    setItems((actual) =>
      actual.map((item) =>
        item.id === id
          ? {
              ...item,
              observaciones,
            }
          : item
      )
    );
  };

  const quitar = (id) => {
    setItems((actual) =>
      actual.filter((item) => item.id !== id)
    );
  };

  const vaciar = () => setItems([]);

  const total = useMemo(
    () =>
      items.reduce(
        (sum, item) =>
          sum +
          Number(item.precio || 0) *
            Number(item.cantidad || 0),
        0
      ),
    [items]
  );

  const unidades = useMemo(
    () =>
      items.reduce(
        (sum, item) =>
          sum + Number(item.cantidad || 0),
        0
      ),
    [items]
  );

  return {
    items,
    agregar,
    cambiarCantidad,
    cambiarObservaciones,
    quitar,
    vaciar,
    total,
    unidades,
  };
}
